<template>
  <v-container>
    <v-row class="py-8">
      <v-col cols="12" sm="12" md="4">
        <img
          :src="basePath + 'assets/images/login/error.svg'"
          class="header-brand-img-login2 centrado-img"
          alt="logo"
        />
      </v-col>
      <v-col cols="12" sm="12" md="8">
        <h1 class="text-h3">{{ $t("index.algoSalioMal") }}</h1>

        <small class="text-h5">
          {{ $t("index.errorInformacionFinanciera") }}
        </small>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      basePath: process.env.VUE_APP_CONTEXT_PATH,
    }
  }
};
</script>
